import { createAction, createSlice } from '@reduxjs/toolkit';

import {
  InstallConversionData,
  ScreenView,
  TrackEvent,
  TrackingState,
} from './tracking.types';
import { State } from '../state.types';
import { persistReducer } from 'redux-persist';
import { AsyncStorage } from '../../storage';

export const trackScreenView = createAction<ScreenView>('tracking/screenView');
export const trackEvent = createAction<TrackEvent>('tracking/event');
export const trackInstallConversion = createAction<InstallConversionData>(
  'tracking/installConversion',
);
export const trackInstallConversionError = createAction<unknown>(
  'tracking/installConversionError',
);

const initialState: TrackingState = {};

const tracking = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    resetInstallConversionData(state) {
      state.installConversionData = undefined;
    },
    storeAppsFlyerUid(state, action) {
      state.appsflyerUid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(trackInstallConversion, (state, action) => {
      state.installConversionData = action.payload;
    });
  },
});

export const { resetInstallConversionData, storeAppsFlyerUid } =
  tracking.actions;

const persistConfig = {
  key: 'tracking',
  storage: AsyncStorage,
};

const persistedReducer = persistReducer(persistConfig, tracking.reducer);

export default persistedReducer;

export const selectInstallConversionData = (state: State) =>
  state.tracking.installConversionData;

export const selectAppsFlyerUid = (state: State) => state.tracking.appsflyerUid;
